import axios from "axios";

import ConvertObjectParamToString from "@/commons/ConvertObjectParamToString";
const deleteWarnDoc = "/api/telcoServices/deleteWarnDoc";
const baseApiFile = "/api/revenue/telcoServices/file?file_id=";

export default class DeclareStatisticYearService {
  private convertObjectParamToStrings: ConvertObjectParamToString = ConvertObjectParamToString.instance;

  public SearchBCTK(querySearch: any, cancelToken): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .post("/api/business/bctk/by-year/search/v2", querySearch, { cancelToken: cancelToken.token })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public AllFeetype(): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(`/api/business/receipt/fee_types`)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public getAllCompany(querySearch?: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(`/api/business/companyList`, querySearch)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public exportExcel(query): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .post(`/api/business/bctk/by-year/excel`, query, { responseType: "blob" })
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
}
